import { AUTH_SIGNIN_WITH_GOOGLE_ONE_TAP_URL } from '@ha/auth/common/routes';

export const OAUTH_SIGNIN_GOOGLE_ONE_TAP_API_ROUTE = `/next/api${AUTH_SIGNIN_WITH_GOOGLE_ONE_TAP_URL}`;
